import { useTranslation } from 'react-i18next'

import { Checkbox, Text } from '@reveni-io/reveni-ui'

import { getFilenameFromUrl } from '@/common/helpers/helpers'

import * as Styles from './styles'

const InvoicesCheckboxes = ({ invoices, invoicesChecked, onCheckInvoice }) => {
  const { t } = useTranslation()
  const filteredInvoices = invoices?.filter(invoice => invoice)

  if (!filteredInvoices?.length) return null

  return (
    <Styles.Container>
      <Text type="titleS">{t('Facturas')}</Text>
      <Styles.CheckboxContainer>
        {filteredInvoices.map((invoice, index) => (
          <Checkbox
            key={index}
            label={getFilenameFromUrl(invoice)}
            checked={invoicesChecked?.find(invoiceChecked => invoiceChecked === invoice)}
            onChange={() => onCheckInvoice(invoice)}
          />
        ))}
      </Styles.CheckboxContainer>
    </Styles.Container>
  )
}

export default InvoicesCheckboxes
